import { Divider } from 'antd'

const ANTDDivider = ({ ...props }) => {
  return <Divider {...props} />
}

export default ANTDDivider
